import axios from "axios";

const API_BASE_URL =
  "https://lastagedocdistro.azurewebsites.net:443/api/ReprocessCallbacks";

export const bulkReprocessApi = {
  reprocess: async (data: any) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/triggers/When_a_HTTP_request_is_received/invoke?api-version=2022-05-01&sp=%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun&sv=1.0&sig=${process.env.REACT_APP_BULK_REPROCESS_SIGNATURE}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error during bulk reprocess:", error);
      throw error;
    }
  },
};
